<h2 class="mt-3 ml-5">Image Prediction</h2>
<hr>
<div class="d-flex justify-content-center">
        
    <form class="was-validated" *ngIf="comboValues | async as cmb" [formGroup]="vsForm" (ngSubmit)="onFormSubmit()">
        <!--URL adres-->
        <div class="mb-3">
            <label for="basic-url" class="form-label">URL Adresi Girin</label>
            <div class="input-group">
              <span class="input-group-text" id="basic-addon3">https://</span>
              <input type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3 basic-addon4" formControlName="urlValue">
            </div>
        </div>
    
        <!--Dosya path yükle-->
        <div class="mb-3">
            <label for="formFile" class="form-label">Bilgisayardan Dosya Yükleyin</label>
            <input class="form-control" type="file" id="formFile" formControlName="filePathValue" accept=".png, .jpge/*, .jpg" (change)="onFileSelected($event)">
        </div>   
    
        <!--Confidence-->
        <div class="mb-3">
            <label class="form-label">Confidence Değeri Girin</label>
            <input class="form-control" type="text" placeholder="0.5" formControlName="confidenceValue" required>
            
            <div class="invalid-feedback">
                *Zorunlu Alan <br> 0-1 arasında bir Confidence değeri girilmesi gerekiyor. (Default 0.5 girebilirsiniz)
            </div>
        </div>
    
        <!--Görev form sonuç kodu-->
        <div class="mb-3">
            <label class="form-label">Görev Form Sonuç Kodunu Girin</label>
            <input class="form-control" type="text" formControlName="gorevFormSonucKoduValue">
        </div>
    
        <!--Proje tag-->
        <div class="mb-3">
            <label class="form-label">Proje Tag Değerini Girin</label>
            <input class="form-control" type="text" formControlName="projeTagValue">
        </div>
    
        <!--Iteration-->
        <div class="mb-3">
            <label class="form-label">Iteration Değeri Seçin</label><br>
            <select class="form-select form-select-sm" required aria-label="Small select example" formControlName="iterationValue">
                <option *ngFor="let iteration of cmb.imageIterations" [value]="iteration">{{iteration}}</option>
            </select>

            <div class="invalid-feedback">*Zorunlu Alan</div>
        </div>
    
        <!--Marka-->
        <div class="mb-3">
            <label class="form-label">Marka Seçin</label><br>
            <select class="form-select form-select-sm" required aria-label="Small select example" formControlName="brandValue">
                <option *ngFor="let brand of cmb.imageBrands" [value]="brand">{{brand}}</option>
            </select>

            <div class="invalid-feedback">*Zorunlu Alan</div>
        </div>
    
        <!--Epoch-->
        <div class="mb-3">
            <label class="form-label">Epoch Değeri Seçin</label><br>
            <select class="form-select form-select-sm" required aria-label="Small select example" formControlName="epochValue">
                <option *ngFor="let epoch of cmb.imageEpoches" [value]="epoch">{{epoch}}</option>
            </select>

            <div class="invalid-feedback">*Zorunlu Alan</div>
        </div>

        <!--IsStackClear-->
        <div class="mb-3">
            <label class="form-label">IsStackClear</label><br>
            <input type="checkbox" [formControl]="isStackClear" />
            <span>{{ isStackClear.value ? 'Aktif' : 'Deaktif' }}</span>           
        </div>
    
        <button type="submit" class="btn btn-success">Formu Gönder</button>            
    </form>

    <div *ngIf="(isFormSubmitting | async)">Bekleyin...</div>

    <!-- <button (click)="test()">Test</button> -->
</div>